import React, { Component } from "react";
import ExternalBrandAcceptPage from "components/external-brand-accept/ExternalBrandAcceptPage";
import ForgotPassword from "login/components/forgot-password";
import Register from "login/components/register";
import UpdatePassword from "login/components/update-password";
import { Route, Switch } from "login/visual-components/decorated-router-components";
import { bool } from "prop-types";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import AcceptableUsePolicy from "util/components/docs/acceptable-use-policy";
import CopyrightPolicy from "util/components/docs/copyright-policy";
import CTAAdvertiserTerms from "util/components/docs/cta-advertiser-terms";
import CTAPurchaserTerms from "util/components/docs/cta-purchaser-terms";
import PrivacyPolicy from "util/components/docs/privacy-policy";
import ReferralsTerms from "util/components/docs/referral-terms";
/* terms and such docs */
import TermsOfUse from "util/components/docs/terms-of-use";
import SendGAPageViews from "v2/components/util/SendGAPageViews";
import ViewMetrics from "v2/components/util/ViewMetrics";
import ContactSupportModal from "visual-components/util/modals/contact-support-modal";
import PriceEliteModal from "visual-components/util/modals/pricing-elite-modal";
import MobileCareers from "./mobile-visual-components/MobileCareers/MobileCareers";
/* mobile pages */
import MobileNetwork from "./mobile-visual-components/MobileNetwork/MobileNetwork";
import MobilePricing from "./mobile-visual-components/MobilePricing/MobilePricing";
import MobileCaseStudy from "./mobile-visual-components/MobileResources/MobileCaseStudy";
/* mobile resources */
import MobileResources from "./mobile-visual-components/MobileResources/MobileResources";
import MobileSmsMarketing from "./mobile-visual-components/MobileSmsMarketing/SmsMarketing";
import MobileSweepstakes from "./mobile-visual-components/MobileSweepstakes/MobileSweepstakes";
import Careers from "./visual-components/Careers/Careers";
import { HomeRedirect } from "./visual-components/HomeRedirect";
import Network from "./visual-components/Network/Network";
import Pricing from "./visual-components/Pricing/Pricing";
import PublicRoutes from "./visual-components/Public/PublicRoutes";
/* case studies */
import CaseStudy from "./visual-components/Resources/CaseStudy";
/* resources */
import Resources from "./visual-components/Resources/Resources";
import ResourcesForEcommerce from "./visual-components/Resources/ResourcesForEcommerce";
import ResourcesForEnterprise from "./visual-components/Resources/ResourcesForEnterprise";
import ResourcesForMedia from "./visual-components/Resources/ResourcesForMedia";
import ResourcesForStartups from "./visual-components/Resources/ResourcesForStartups";
import SmsMarketing from "./visual-components/SmsMarketing/SmsMarketing";
import Sweepstakes from "./visual-components/Sweepstakes/Sweepstakes";

export default class App extends Component {
  static propTypes = {
    forceMobile: bool,
  };

  render() {
    const { forceMobile } = this.props;

    return (
      <div>
        <Helmet titleTemplate="DojoMojo - %s">
          <title>The Home of Partnership Marketing</title>
          <meta
            content="Growth Acquisition Made Easy. DojoMojo is a platform to build a true end-to-end funnel for customer growth and engagement."
            name="description"
          />
          <meta property="og:title" content="DojoMojo" />
          <meta
            property="og:description"
            content="Growth Acquisition Made Easy. DojoMojo is a platform to build a true end-to-end funnel for customer growth and engagement."
          />
          <meta property="og:type" content="website" />
          <style type="text/css">{`
            @media (max-width: 600px) { html, body { width: 100%; overflow-x: hidden; }
          `}</style>
          <meta name="viewport" content="user-scalable=no, width=device-width, initial-scale=1.0" />
          <meta name="mobile-web-app-capable" content="yes" />
        </Helmet>
        <ViewMetrics />
        <SendGAPageViews />
        <Switch forceMobile={forceMobile}>
          {/* `/` is served by the isolated HomeV2 bundle; bounce to the server. */}
          <Route exact path="/" component={HomeRedirect} />
          <Route path="/sweepstakes" component={Sweepstakes} mobileComponent={MobileSweepstakes} />
          <Route
            path="/sms-marketing"
            component={SmsMarketing}
            mobileComponent={MobileSmsMarketing}
          />
          <Route path="/network" component={Network} mobileComponent={MobileNetwork} />
          <Route path="/pricing" component={Pricing} mobileComponent={MobilePricing} />
          <Route exact path="/careers" component={Careers} mobileComponent={MobileCareers} />
          <Route path="/resources/all" component={Resources} mobileComponent={MobileResources} />
          <Route
            path="/resources/for-ecommerce"
            component={ResourcesForEcommerce}
            mobileComponent={MobileResources}
          />
          <Route
            path="/resources/for-media"
            component={ResourcesForMedia}
            mobileComponent={MobileResources}
          />
          <Route
            path="/resources/for-startups"
            component={ResourcesForStartups}
            mobileComponent={MobileResources}
          />
          <Route
            path="/resources/for-enterprise"
            component={ResourcesForEnterprise}
            mobileComponent={MobileResources}
          />

          <Route
            path="/case_studies/:case"
            component={CaseStudy}
            mobileComponent={MobileCaseStudy}
          />

          <Route
            path="/(brand|opportunities)"
            render={() => <PublicRoutes forceMobile={forceMobile} />}
          />

          <Route path="/terms-of-use" component={TermsOfUse} />
          <Route path="/cta-advertiser-terms" component={CTAAdvertiserTerms} />
          <Route path="/cta-purchaser-terms" component={CTAPurchaserTerms} />
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/copyright" component={CopyrightPolicy} />
          <Route path="/acceptable-use" component={AcceptableUsePolicy} />
          <Route path="/referral-terms-conditions" component={ReferralsTerms} />

          <Route path="/register/:referralId?" component={Register} />
          <Route path="/update-password" component={UpdatePassword} />
          <Route path="/forgot" component={ForgotPassword} />
          <Route path="/external-brand-accept/:code" component={ExternalBrandAcceptPage} />
          {/* <Route path="/elite-request" component={EliteRequest} />*/}

          <Route render={() => <Redirect to="/" />} />
        </Switch>
        <ContactSupportModal />
        <PriceEliteModal />
      </div>
    );
  }
}
